import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getResource } from '../redux/actionCreators/resources'
import Rows from './bootstrap/Rows'
import Inflection from 'inflection'

import { MODEL_SENSOR_FIELDS } from '../models.js'
import Resources from './Resources'
import AssetEvents from './AssetEvents'

class Asset extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTabName: null,
      activeTab: null
    }
  }
  
  componentDidMount() {
    if (this.props.canMakeAssetRequest) this.props.getAsset()
      
    if (this.props.assetCustomPropsLoaded && this.state.activeTab === null) {
      this.showCustomPropertiesTab()
    }
  }

  componentDidUpdate() {
    if (this.props.canMakeAssetRequest && !this.props.assetLoaded) this.props.getAsset()
    
    if (this.props.assetCustomPropsLoaded && this.state.activeTab === null) {
      this.showCustomPropertiesTab()
    }
  }
  
  showCustomPropertiesTab() {
    if (!this.props.assetCustomPropsLoaded) return
    let custom_properties = Object.keys(this.props.asset.custom_properties).map((key, index) => {
      let value = this.props.asset.custom_properties[key]
      if (typeof value !== "string") value = JSON.stringify(value)
      return [
        {value: Inflection.titleize(key), className: "col-3 font-weight-bold"},
        {value}
      ]
    });
    
    this.setState({
      activeTabName: "custom_properties",
      activeTab: (
        <div className="card-body">
          <Rows rows={custom_properties} />
        </div>
      )
    })
  }
  
  showSensorsTab() {
    this.setState({
      activeTabName: "sensors",
      activeTab: (
        <div className="card-body">
          <Resources resourceType="sensors" idField="dev_eui" fields={MODEL_SENSOR_FIELDS} listParams={{asset_id: this.props.match.params.assetId}} />
        </div>
      )
    })
  }
  
  showEventsTab() {
    this.setState({
      activeTabName: "events",
      activeTab: (
        <div className="card-body">
          <AssetEvents assetId={ this.props.match.params.assetId } />
        </div>
      )
    })
  }
  
  render() {
    if (!this.props.assetLoaded) return (
      <div />
    )
    
    return (
      <div className="px-5 pt-3">
        <div className="card">
          <div className="card-header">
            {this.props.asset.name}
          </div>
          <div className="card-body">
            <Rows rows={[
              [{value: "Id", className: "col-2 font-weight-bold"}, {value: this.props.asset.id}],
              [{value: "Name", className: "col-2 font-weight-bold"}, {value: this.props.asset.name}],
              [{value: "Asset Type", className: "col-2 font-weight-bold"}, {value: this.props.asset.asset_type_id}],
              [{value: "Latitude", className: "col-2 font-weight-bold"}, {value: this.props.asset.latitude}],
              [{value: "Longitude", className: "col-2 font-weight-bold"}, {value: this.props.asset.longitude}]
            ]} />
            
            <div className="card mt-3">
              <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs">
                  <li className="nav-item">
                    <span className={ this.state.activeTabName === "custom_properties" ? "nav-link active" : "nav-link" } onClick={() => {this.showCustomPropertiesTab()}} >Custom Properties</span>
                  </li>
                  <li className="nav-item">
                    <span className={ this.state.activeTabName === "sensors" ? "nav-link active" : "nav-link" } onClick={() => {this.showSensorsTab()}} >Sensors</span>
                  </li>
                  <li className="nav-item">
                    <span className={ this.state.activeTabName === "events" ? "nav-link active" : "nav-link" } onClick={() => {this.showEventsTab()}} >Events</span>
                  </li>
                </ul>
              </div>
              {this.state.activeTab}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  assetLoaded: function() {
    let assetList = state.api.assets || {}
    let asset = assetList[ownProps.match.params.assetId] || {}
    return asset.isLoaded || false
  }(),
  canMakeAssetRequest: function() {
    let assetList = state.api.assets || {}
    let asset = assetList[ownProps.match.params.assetId] || {}
    return state.oidc.user && !state.oidc.user.expired && !(asset.isLoading || false) && !(asset.isError || false)
  }(),
  asset: function() {
    let assetList = state.api.assets || {}
    return assetList[ownProps.match.params.assetId] || {}
  }(),
  assetCustomPropsLoaded: function() {
    let assetList = state.api.assets || {}
    let asset = assetList[ownProps.match.params.assetId] || {}
    return asset.custom_properties !== undefined
  }()
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAsset: () => {dispatch(getResource("assets", ownProps.match.params.assetId))}
})

export default connect(
  mapStateToProps,
  mapDispatchToProps 
)(Asset)